import React from 'react';
import styled from 'styled-components';

// Caremate CI/CD: build once, promote the image dev → staging → prod on GKE, with a
// manual approval gate before production.
const Wrap = styled.div`
  display: flex;
  align-items: stretch;
  margin-top: 16px;
  padding: 24px 14px 18px;
  background: var(--light-navy);
  border: 1px solid var(--lightest-navy);
  border-radius: var(--border-radius);
  overflow-x: auto;

  .stage {
    position: relative;
    flex: 1 0 auto;
    min-width: 88px;
    text-align: center;
  }
  .box {
    margin: 0 6px;
    padding: 12px 8px;
    background: var(--navy);
    border: 1px solid var(--lightest-navy);
    border-radius: var(--border-radius);
  }
  .box .n {
    color: var(--lightest-slate);
    font-size: var(--fz-sm);
    font-weight: 600;
  }
  .box .s {
    margin-top: 4px;
    color: var(--slate);
    font-size: var(--fz-xxs);
    line-height: 1.3;
  }
  .stage.prod .box {
    background: var(--green-tint);
    border-color: var(--green);
  }
  .stage.prod .n {
    color: var(--green);
  }

  .arrow {
    display: flex;
    flex: 0 0 16px;
    align-items: center;
    justify-content: center;
    color: var(--dark-slate);
  }

  .gate {
    position: absolute;
    top: -10px;
    left: 50%;
    transform: translateX(-50%);
    padding: 1px 7px;
    white-space: nowrap;
    color: var(--navy);
    background: #ffca6b;
    border-radius: 3px;
    font-family: var(--font-mono);
    font-size: 10px;
    font-weight: 700;
  }
`;

const STAGES = [
  { n: 'Push', s: 'GitHub' },
  { n: 'Build', s: 'Cloud Build · image Docker' },
  { n: 'Registry', s: 'Artifact Registry' },
  { n: 'dev', s: 'GKE' },
  { n: 'staging', s: 'GKE' },
  { n: 'prod', s: 'GKE', prod: true, gate: 'approbation manuelle' },
];

export const CarematePipeline = () => (
  <Wrap>
    {STAGES.map((st, i) => (
      <React.Fragment key={st.n}>
        {i > 0 && <div className="arrow">→</div>}
        <div className={st.prod ? 'stage prod' : 'stage'}>
          {st.gate && <div className="gate">{st.gate}</div>}
          <div className="box">
            <div className="n">{st.n}</div>
            <div className="s">{st.s}</div>
          </div>
        </div>
      </React.Fragment>
    ))}
  </Wrap>
);
